import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import { CoreContext } from 'context/CoreContext';
import { useContext, useState } from 'react';
import { CompanyButtonContainer } from '../Sample/styled';
import Wrapper from '../Wrapper';

const ConfirmDate = ({ title, onConfirm, placeholder, loading }) => {
  const { setModal } = useContext(CoreContext);
  const [dateValue, setDateValue] = useState();

  return (
    <Wrapper onClose={() => setModal(null)} title={title ?? 'Data'}>
      <div
        style={{
          paddingTop: '2rem',
          paddingBottom: '2rem',
        }}
      >
        <Input
          type={'date'}
          onChange={(e) => {
            setDateValue(e.target.value);
          }}
          value={dateValue}
          placeholder={placeholder}
        />
      </div>
      <CompanyButtonContainer style={{ padding: 0 }}>
        <Button
          onClick={() => setModal(null)}
          color="light-grey"
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          color="blue"
          onClick={() => onConfirm(dateValue)}
          between
          disabled={loading || !dateValue}
        >
          Confirmar
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
};

export default ConfirmDate;
